
import { Email } from '../types';
import { useEmailFetchOperations } from './utils/useEmailFetchOperations';
import { useEmailMarkOperations } from './utils/useEmailMarkOperations';

interface UseEmailCrudOperationsProps {
  emails: Email[];
  setEmails: (emails: Email[]) => void;
  setCurrentEmail: (email: Email | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: boolean) => void;
  setHasMoreEmails: (hasMore: boolean) => void;
  setTotalEmailsInFolder: (total: number) => void;
  setTotalPages: (pages: number) => void;
}

export const useEmailCrudOperations = ({
  emails,
  setEmails,
  setCurrentEmail,
  setLoading,
  setError,
  setHasMoreEmails,
  setTotalEmailsInFolder,
  setTotalPages,
}: UseEmailCrudOperationsProps) => {
  
  const { fetchEmails, getEmail } = useEmailFetchOperations({
    emails,
    setEmails,
    setCurrentEmail,
    setLoading,
    setError,
    setHasMoreEmails,
    setTotalEmailsInFolder,
    setTotalPages,
  });

  const { markAsRead, markAsUnread } = useEmailMarkOperations({
    emails,
    setEmails,
  });

  return {
    fetchEmails,
    getEmail,
    markAsRead,
    markAsUnread,
  };
};
